export { default as TableCellHead } from './table-cell-head';
